import React from "react";
import Navbar from "../Components/Navbar";
import Userprofile from "../Components/userprofile";
import Footer from "../Components/Footer";

const Profile = () => {
  return (
    <div>
      <Navbar />
      <Userprofile />
      <Footer />
    </div>
  );
};

export default Profile;
